import { KatashikiParams } from "@/model/KatashikiParams";
import store from "@/store";

export default class KatashikiService {

  clearState() {
    store.dispatch("KatashikiStore/clearState");
  }

  setKatashikiParams(data: KatashikiParams) {
    store.dispatch("KatashikiStore/setKatashikiParams", data);
  }

  getKatashikiParams(): KatashikiParams {
    return store.getters["KatashikiStore/getKatashikiParams"];
  }

}

